import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://gwmincfmtcqkjceozkbs.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3bWluY2ZtdGNxa2pjZW96a2JzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjU3NTc1MzEsImV4cCI6MjA0MTMzMzUzMX0.NbBfsh2i34_NyDZQiY7OjDii_z_XrTvjICBiTMPAdMg'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)